import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { MDT_URL, ADMIN_URL } from './constant/BaseApiUrl';

export default class TourManagementService {
  getTourGateway() {
    return axios.get(`${MDT_URL}${ApiKey.TOUR_COMBINATION}/list-management`);
  }

  addTourGateway(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.TOUR_COMBINATION}`, payload);
  }

  editTourGateway(payload: any) {
    return axios.put(`${MDT_URL}${ApiKey.TOUR_COMBINATION}`, payload);
  }

  deleteTourGateway(payload: any) {
    return axios.delete(`${MDT_URL}${ApiKey.TOUR_COMBINATION}/delete`, { data: payload });
  }

  getListManagementTour() {
    return axios.get(`${MDT_URL}${ApiKey.TOUR_LIST_MANAGEMENT}`);
  }

  getTourInfo(ttsCode: string) {
    return axios.get(`${MDT_URL}${ApiKey.TOUR}/${ttsCode}/info`);
  }

  addTourDetail(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.TOUR}`, payload);
  }

  editTourDetail(payload: any) {
    return axios.put(`${MDT_URL}${ApiKey.TOUR}`, payload);
  }

  deleteTourDetail(payload: any) {
    return axios.delete(`${MDT_URL}${ApiKey.DELETE_TOUR_DETAIL}`, { data: payload });
  }

  getNotes(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.GET_NOTES}`, payload);
  }

  addNote(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.ADD_NOTE}`, payload);
  }

  searchTourAuto(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.AUTO_SEARCH}`, payload);
  }

  addDataAutoSearch(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.ADD_DATA_AUTO_SEARCH}`, payload);
  }

  getTourCombinationGateway() {
    return axios.get(`${MDT_URL}${ApiKey.TOUR_COMBINATION}/${ApiKey.GET_GATEWAYS}`);
  }

  getTourCombinationDestByGateCode(gateCode: string) {
    return axios.get(`${MDT_URL}${ApiKey.TOUR_COMBINATION}/${gateCode}/${ApiKey.DESTINATIONS}`);
  }

  getTourCombinationGatewayByDestCode(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.TOUR_COMBINATION}/${ApiKey.GET_GATEWAYS}`, payload);
  }

  getTourDetail(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.TOUR_COMBINATION}/${ApiKey.TOUR}`, payload);
  }

  getUrlPreview() {
    return `${MDT_URL}${ApiKey.TOUR_COMBINATION}/${ApiKey.PREVIEW}`;
  }

  getUrlPreviewTour() {
    return `${MDT_URL}${ApiKey.TOUR}/${ApiKey.PREVIEW}`;
  }

  importTourGateDes(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.TOUR_COMBINATION}/${ApiKey.IMPORT}`, payload);
  }

  getVersionRevertTourGateDes(type: string) {
    return axios.get(`${ADMIN_URL}${ApiKey.ADMINISTRATION}/file?fileType=${type}`);
  }

  getPreviewFileTourGateDes(fileName: string) {
    return axios.post(`${MDT_URL}${ApiKey.TOUR_COMBINATION}/${ApiKey.URL_FILE}/${ApiKey.PREVIEW_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  getPreviewFileTourDetail(fileName: string) {
    return axios.post(`${MDT_URL}${ApiKey.TOUR}/${ApiKey.URL_FILE}/${ApiKey.PREVIEW_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  revertFileTourGateDes(fileName: string) {
    return axios.post(`${MDT_URL}${ApiKey.TOUR_COMBINATION}/${ApiKey.REVERT_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  revertFileTourDetail(fileName: string) {
    return axios.post(`${MDT_URL}${ApiKey.TOUR}/${ApiKey.REVERT_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  importTourDetail(payload: any) {
    return axios.post(`${MDT_URL}${ApiKey.TOUR}/${ApiKey.IMPORT}`, payload);
  }
}
